import {
    LookupDataEnums,
    NotePurposeTypesEnum,
    NoteStatusTypes,
    NoteTypes,
} from '../../../utilities/Constants';

import { DocumentTitle } from '../../../components/shared/DocumentTitle';
import { DocumentTypeEnum } from '../../../utilities/DbConstants';
import { INoteModel } from '../../../interfaces/INote';
import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { NoteEditor } from '../../../components/notes/note-editor/NoteEditor';
import { useGetNoteCategoryTypes } from '../../../shared/react-query-hooks/useGetNoteCategoryTypes';
import { useNavigate } from 'react-router-dom';

export function QuadZoneNotes() {
    const navigate = useNavigate();

    const noteCategoryTypesApi = useGetNoteCategoryTypes(LookupDataEnums.ZoneNoteCategories);

    const handleCancelNoteEditor = () => {
        navigate(LocalRoutes.QuadDashboard);
    };

    const handleSaveNoteComplete = (noteItem: INoteModel) => {
        navigate(LocalRoutes.QuadDashboard);
    };

    return (
        <div>
            <DocumentTitle title="Quad - Zone Notes" hideZoneName />
            <NoteEditor
                currentNote={{
                    status: { id: NoteStatusTypes.Open },
                    purpose: { id: NotePurposeTypesEnum.Info },
                    type: { id: NoteTypes.ZoneNote },
                }}
                onCancel={handleCancelNoteEditor}
                onSaveComplete={handleSaveNoteComplete}
                noteCategoryTypes={noteCategoryTypesApi?.data ?? []}
                isQuadNoteEditor
            />
        </div>
    );
}
